import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-footer-all',
  styleUrl: 'footer.css',
  shadow: false,
})
export class Footer {

  render() {
    return (
      <cwru-center max="var(--max-container)">
        <footer aria-label="footer" class="footer">
            <cwru-switcher threshold="900px">
              <cwru-footer-university-block></cwru-footer-university-block>
              <slot />
              <cwru-footer-links></cwru-footer-links>
            </cwru-switcher>
        </footer>
      </cwru-center>
    );
  }
}
